import React from 'react';
import './styles.scss';

const Immotech = () => {
  return (
    <section className="immotech-section">
      <div className="immotech-background">
        <img src="/2025/immotech/images/background.svg" alt="" />
      </div>
      
      <div className="immotech-content">
        <div className="immotech-main">
          {/* Left side - Collage */}
          <div className="immotech-collage">
            <img 
              src="/2025/immotech/images/collageTest.png" 
              alt="Immotech conferences and events"
              loading="lazy"
            />
          </div>

          {/* Right side - Logo, Subtitle, Description */}
          <div className="immotech-right">
            <img 
              src="/2025/immotech/icons/logo.svg" 
              alt="Immotech" 
              className="immotech-logo"
            />
            <p className="immotech-subtitle">
              Софтуерът за управление на имот, домакинство и етажна собственост
            </p>
            <p className="immotech-description">
              Изградихме солидна база от доволни потребители в Германия за изминалата година. Подготвихме основата за масова популяризация и засилено разпространение в основните за Имотех пазари. 2026-та година ще бъде интересна и успешна - обещаваме!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Immotech;
